import { render, staticRenderFns } from "./BankTransactionToPaymentModal.vue?vue&type=template&id=53168074"
import script from "./BankTransactionToPaymentModal.vue?vue&type=script&lang=js"
export * from "./BankTransactionToPaymentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports